import { Button, ButtonLink, Icon, Select, Toggle } from '@/components/ui';
import { useSelector } from 'react-redux';
import { hideAdult, getAdultState } from '@/stores/slices/popupSlice';
import React, { useState, useMemo, useEffect } from 'react';
import useLadyService from '@/services/LadyService';

import './adult.scss';
import { SelectCountry } from '../../ui';
import {
	getCountriesData,
	getUserCurrentCity,
} from '../../../stores/slices/userSlice';
import Popup from '../Popup';
import { getDisabledFilters } from '@/stores/slices/filterSlice';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';
import { set } from 'date-fns';

const Adult = () => {
	const { dispatch, city, scrollToTop, lang, t } = useLadyService();
	const FILTER = useFilterLogicContext();

	const disabled_filters = useSelector(getDisabledFilters);

	const disabled = useMemo(() => {
		return new Set(disabled_filters);
	}, [disabled_filters]);

	const [selected_gender, setSelectedGender] = useState('all');

	const other_options = useMemo(() => {
		return {
			gender: [
				{
					id: 1000,
					title: t('allads'),
					value: 'all',
				},

				{
					id: 67,
					title: t('girls'),
					value: 'female',
					disabled: disabled?.has('genderFemale'),
					icon: 'gender-female',
				},

				{
					id: 68,
					title: t('guys'),
					value: 'male',
					disabled: disabled?.has('genderMale'),
					icon: 'gender-male',
				},

				{
					id: 66,
					title: t('trans'),
					value: 'trans',

					disabled: disabled?.has('genderTrans'),

					icon: 'gender-trans',
				},

				{
					id: 69,
					title: t('couples'),
					value: 'couple',
					disabled: disabled?.has('genderCouple'),
					icon: 'gender-couple',
				},
			].sort((a, b) => {
				if (a.value === selected_gender) {
					return -1;
				}
				if (b.value === selected_gender) {
					return 1;
				}
				return 0;
			}),
		};
	}, [disabled, t, selected_gender]);

	const setGender = async (value) => {
		const found = other_options.gender.find((i) => i.value === value);

		const obj = {
			value: value,
			title: found ? found.title : '-',
			icon: found ? found.icon : '-',
		};

		setSelectedGender(obj);

		if (value !== 'all') {
			FILTER.handleInstantRadio({ gender: [value] });
		} else {
			FILTER.handleInstantRadio({ gender: [] });
		}

		localStorage.setItem('save_gender_filter', value);
	};

	const adultPopupState = useSelector(getAdultState);

	const languages = {
		main_title: '',
		options: [
			{ id: 1, link: `/en/${city}`, title: 'EN', value: 'en' },
			{ id: 2, link: `/ru/${city}`, title: 'RU', value: 'ru' },
			{ id: 3, link: `/cz/${city}`, title: 'CZ', value: 'cz' },
			{ id: 3, link: `/de/${city}`, title: 'DE', value: 'de' },
			{ id: 3, link: `/sk/${city}`, title: 'SK', value: 'sk' },
		],
	};

	const handleAdult = () => {
		dispatch(hideAdult(false));
		scrollToTop();
	};
	const countriesData = useSelector(getCountriesData);
	const [currentActive, setCurrentActive] = useState('');
	const currentCity = useSelector(getUserCurrentCity);

	useEffect(() => {
		const savedGender = localStorage.getItem('save_gender_filter');
		if (FILTER.filterState.gender.length === 1 && other_options.gender) {
			const transformed = FILTER.filterState.gender.map((i) =>
				FILTER.getFilterValue(i, true) === 'couples'
					? 'couple'
					: FILTER.getFilterValue(i, true),
			);

			const found = other_options.gender.find(
				(i) => i.value === transformed[0],
			);

			const obj = {
				value: transformed[0],
				title: found ? found.title : '-',
				icon: found ? found.icon : '-',
			};

			setSelectedGender(obj);
		} else if (other_options.gender) {
			if (savedGender) {
				const found = other_options.gender.find(
					(i) => i.value === savedGender,
				);
				if (found) {
					setGender(found.value);
				} else {
					setSelectedGender(other_options.gender[0]);
				}
			}
			setSelectedGender(other_options.gender[0]);
		}
	}, [FILTER.filterStateIndicator]);

	return (
		<Popup
			open={!!adultPopupState}
			id={'adultPopup'}
			wrapperClazz="adult-popup adult"
		>
			<div className="adult-popup__top">
				<Icon
					size={''}
					spritePath={'18-popup'}
					clazz={'adult-popup__svg'}
				/>
				<p className="p2 text-center">{t('popuptext18')}.</p>

				<div className="adult-popup__inner">
					<h2>{t('selecttheme')}</h2>
					<div className="adult-popup__actions">
						<Select
							name={'gender_select'}
							onChange={setGender}
							options={other_options.gender}
							arrowSize={'m'}
							withoutTitle={true}
							withIcon={true}
							clazzWrapper={'select-field'}
							controlledValue={selected_gender.value}
							controlledTitle={selected_gender.title}
							controlledIcon={selected_gender.icon}
							clazz={'mt-0'}
							clazzSvg={'color-green'}
						/>

						<Select
							options={languages.options}
							clazz={'button button-xs'}
							arrowSize={'s'}
							size={'xs'}
							sorted={true}
							name={'language'}
						></Select>
						<Toggle
							type="theme"
							id={'toggle-theme-adult'}
						></Toggle>
					</div>
				</div>

				<p className="p2 text-center mt-12">{t('popupcookies')}.</p>

				<span className={'adult-popup__city mb-8'}>
					{t('yourcity') + ' / ' + t('country').toLowerCase()}:
					<SelectCountry
						data={countriesData}
						name={'city-create-adult'}
						clazz={`button button-xs select-city`}
						arrowSize={'m'}
						type={'flag'}
						defaultTitle={currentCity.title}
						currentActiveIndex={currentActive}
						isMain={true}
						activeCountry={currentCity.icon}
						setActive={setCurrentActive}
					/>
				</span>
			</div>

			<div className="adult-popup__bottom">
				<h2 className={'adult-popup__title title'}>
					{t('areyouolder')}
				</h2>
				<p className="p2 text-center">
					{t('iamolder')}{' '}
					<a
						href={`/provisions`}
						target="_blank"
					>
						{t('provisions')}
					</a>
					.
				</p>
				<div className="w-100 d-flex gap-8 justify-center">
					<Button
						size={'m'}
						clazz={'button--primary button-l'}
						buttonType={'submit'}
						onClick={handleAdult}
					>
						{t('yes')}
					</Button>
					<ButtonLink
						href={'https://www.google.com'}
						size={'m'}
						clazz={'button--secondary button-l'}
						buttonType={'submit'}
					>
						{t('no')}
					</ButtonLink>
				</div>
			</div>
		</Popup>
	);
};

export default Adult;
